import '@material/web/icon/icon.js'
import '@operato/dataset/ox-data-ooc-brief-view.js'

import gql from 'graphql-tag'
import { css, html, LitElement, nothing } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { client } from '@operato/graphql'
import { i18next, localize } from '@operato/i18n'
import { ScrollbarStyles } from '@operato/styles'

@customElement('activity-ooc-resolve-edit')
class OocResolveActivityEdit extends localize(i18next)(LitElement) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);
      }

      div[content] {
        flex: 1;
        flex-direction: column;

        display: flex;
        overflow: auto;
      }

      ox-data-ooc-brief-view {
        flex: 1;
        padding: var(--spacing-large);
        overflow: auto;
      }

      label[action] {
        display: flex;
        flex-direction: column;

        padding: var(--spacing-large);
      }

      label[action] h2 {
        display: flex;

        color: var(--title-text-color);
        text-transform: capitalize;
        margin: var(--title-margin);
        align-items: center;
      }

      md-icon {
        color: var(--status-danger-color);
      }

      textarea {
        border: var(--input-field-border);
        border-radius: var(--spacing-small);
        margin: var(--spacing-medium);
        padding: var(--spacing-medium);
        font: var(--input-field-font);
        color: var(--md-sys-color-on-surface);
        background: var(--md-sys-color-surface-variant);

        resize: none;
        outline: none;
        min-height: 200px;
      }
    `
  ]

  @property({ type: Object }) input?: any
  @property({ type: Object }) output?: any
  @property({ type: Object }) activityThread?: any

  @state() dataOoc?: any

  @query('textarea') actionTextArea!: HTMLTextAreaElement

  render() {
    const action = this.output?.action
    const state = this.activityThread?.state
    const editable = state == 'unassigned' || state == 'assigned' || state == 'started'

    return html`
      <div content>
        <ox-data-ooc-brief-view .dataOoc=${this.dataOoc}></ox-data-ooc-brief-view>
      </div>

      <!-- <ox-data-ooc-correction-part .dataOoc=${this.dataOoc}></ox-data-ooc-correction-part> -->

      ${editable
        ? html`
            <label action>
              <h2><md-icon>build_circle</md-icon>&nbsp;<span>${i18next.t('label.corrective action')}</span></h2>
              <textarea
                placeholder=${String(i18next.t('text.corrective action placeholder'))}
                .value=${action || ''}
                @change=${this.onChangeAction}
              ></textarea>
            </label>
          `
        : nothing}
    `
  }

  onChangeAction(e: Event) {
    this.output ||= {}
    this.output.action = (e.target as HTMLTextAreaElement).value

    this.dispatchEvent(
      new CustomEvent('change', {
        detail: this.output
      })
    )
  }

  updated(changes) {
    if (changes.has('input')) {
      this.fetchDataOoc()
    }
  }

  async fetchDataOoc() {
    const id = this.input.dataOocId

    if (id) {
      const response = await client.query({
        query: gql`
          query ($id: String!) {
            dataOoc(id: $id) {
              id
              name
              description
              ooc
              oos
              state
              type
              useCase
              data
              judgment
              history
              correctiveAction
              correctiveInstruction
              dataSet {
                id
                name
                monitorType
                monitorView
              }
              dataItems {
                name
                description
                active
                hidden
                tag
                group
                subgroup
                type
                unit
                options
                quota
                spec
                stat
              }
              workDate
              workShift
              reviewer {
                id
                name
              }
              corrector {
                id
                name
              }
              collectedAt
              reviewedAt
              correctedAt
            }
          }
        `,
        variables: {
          id
        }
      })

      const dataOoc = {
        ...response.data.dataOoc
      }

      if (this.activityThread?.output) {
        dataOoc.correctiveAction = this.activityThread.output.action
        dataOoc.correctedAt = this.activityThread.updatedAt
        dataOoc.corrector = this.activityThread.assignee
      }

      this.dataOoc = dataOoc
    }
  }
}
